import { useEffect, useMemo, useState } from 'react'
import { api } from '../../api/client'
import { useToast } from '../../hooks/useToast'
import type { CaseStudy } from '../../types'

const SECTORS = [
  'Retail & consumer',
  'Healthcare',
  'Public sector',
  'Financial services',
  'Insurance',
  'Betting & gaming',
  'Technology',
]

export function LibraryView() {
  const toast = useToast()
  const [cases, setCases] = useState<CaseStudy[]>([])
  const [q, setQ] = useState('')
  const [sector, setSector] = useState('')

  useEffect(() => {
    api
      .caseStudies()
      .then(setCases)
      .catch((e) => toast(e.message))
  }, [toast])

  // 18 case studies — filtering client-side is the right call at this size.
  const results = useMemo(() => {
    const needle = q.toLowerCase().trim()
    return cases.filter((c) => {
      if (sector && c.sector !== sector) return false
      if (!needle) return true
      return `${c.client} ${c.title} ${c.tags} ${c.cap} ${c.outcome} ${c.challenge}`
        .toLowerCase()
        .includes(needle)
    })
  }, [cases, q, sector])

  return (
    <div className="view on">
      <div className="eyebrow">Knowledge</div>
      <h1 className="disp">Case Studies</h1>
      <p className="lede">
        Search Burendo's case studies by client, capability, technology or theme — the same evidence the
        brief generator matches against.
      </p>

      <div className="libtools">
        <input
          className="tx"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search e.g. loyalty, cloud, DevOps, NHS, peak trading…"
        />
        <select className="tx" value={sector} onChange={(e) => setSector(e.target.value)}>
          <option value="">All sectors</option>
          {SECTORS.map((s) => (
            <option key={s}>{s}</option>
          ))}
        </select>
      </div>

      <div className="libgrid">
        {results.map((c) => (
          <div className="libcard" key={c.id}>
            <div className="lc-sec">{c.sector}</div>
            <div className="lc-client">
              {c.client}
              {c.restricted && <span className="badge-r">Restricted</span>}
            </div>
            <div className="lc-title">{c.title}</div>
            <div className="lc-out">{c.outcome}</div>
            <div className="lc-cap">{c.cap}</div>
            {c.url && (
              <a className="lc-link" href={c.url} target="_blank" rel="noopener noreferrer">
                View live service ↗
              </a>
            )}
          </div>
        ))}

        {results.length === 0 && (
          <div className="empty" style={{ gridColumn: '1/-1' }}>
            <div className="ico">⌕</div>
            No case studies match “{q}”.
          </div>
        )}
      </div>
    </div>
  )
}
